import React from 'react'
import { withI18nContext, useTranslation } from '@mc/i18n'
import i18nInstance from '../../i18n/i18nInstance'
import { toTime } from '../utils'
import { VideoControl } from './VideoControl'
import { useVideo } from '..'

/**
 * Displays the current time and duration
 */
export const VideoTime = withI18nContext(i18nInstance)(() => {
  const { duration, time } = useVideo()
  const { t } = useTranslation('@mc/video')

  return (
    <VideoControl className='mc-video__time'>
      <span>
        {t('video.time', { time: toTime(time), duration: toTime(duration) })}
      </span>
    </VideoControl>
  )
})
